import type { ComponentType, ReactNode } from 'react';
import type { IconProps } from '../icons';

export type BadgeTone = 'scale' | 'boolean' | 'photo' | 'comment' | 'critical' | 'na' | 'excluded' | 'neutral';

export interface BadgeProps {
  tone?: BadgeTone;
  icon?: ComponentType<IconProps>;
  /** `square` for what a thing *is*, `pill` for how it *behaves*. */
  shape?: 'pill' | 'square';
  title?: string;
  children: ReactNode;
}

/**
 * Colour, icon and text together — never colour alone.
 *
 * <p>Two readers in every store cannot tell the red badge from the amber one, and the old
 * uppercase monospace chips made all of them equally hard to read at a glance.</p>
 */
export function Badge({ tone = 'neutral', icon: Icon, shape = 'pill', title, children }: BadgeProps) {
  return (
    <span className={`nv-badge nv-badge--${tone}${shape === 'square' ? ' nv-badge--square' : ''}`} title={title}>
      {Icon ? <Icon size={12} strokeWidth={2.25} /> : null}
      {children}
    </span>
  );
}
